import type React from 'react';
import { Box, Title } from '@nimbus-ds/components';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';

interface PaymentDetailsTitleProps {
  isMultiplePayments: boolean;
}

function PaymentDetailsTitle({
  isMultiplePayments,
}: Readonly<PaymentDetailsTitleProps>): React.JSX.Element | null {
  const t = useTranslationOrders('cardPayment');

  if (!isMultiplePayments) {
    return null;
  }

  return (
    <Box paddingBottom="4">
      <Title as="h5" color="neutral-textHigh">
        {t('multiplePaymentsType')}
      </Title>
    </Box>
  );
}

export default PaymentDetailsTitle;
